@file:Suppress("DEPRECATION")
package org.example.newportfolio.components.sections.works

import androidx.compose.runtime.*
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import org.example.newportfolio.components.sections.works.components.WorkItem
import org.example.newportfolio.components.sections.works.components.WorkItemsSimpleGridVariant
import org.example.newportfolio.components.widgets.section.SectionContainer
import org.example.newportfolio.models.Section
import org.example.newportfolio.models.Work
import org.example.newportfolio.utils.Res
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.overlay
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.example.newportfolio.theme.fonts.*
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun WorksSection() {
    val breakpoint = rememberBreakpoint()
    SectionContainer(
        modifier = Modifier,
        section = Section.Works,
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        TextContent(breakpoint = breakpoint)
        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 2, md = 3, lg = 4, xl = 4),
            variant = WorkItemsSimpleGridVariant
        ) {
            // Stagger reveal: each card fades up ~70ms after the previous one
            // as the grid enters the viewport. Cap at 8 (animations.css ships
            // stagger-0 through stagger-7); beyond that the wait stops feeling
            // like motion and starts feeling like a stall.
            //
            // A real anchor (Silk Link), not a div onClick: keyboard focus +
            // Enter, cmd/ctrl-click into a new tab, and crawlable hrefs to the
            // case studies all come for free, while Link still routes
            // client-side.
            Work.entries.forEachIndexed { index, work ->
                Link(
                    path = "/project/${work.name.lowercase()}",
                    modifier = Modifier
                        .display(DisplayStyle.Block)
                        .classNames("scroll-reveal", "stagger-${index % 8}"),
                    variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
                ) {
                    WorkItem(work = work)
                }
            }
            MoreIsYetToCome()
        }
    }
}

@Composable
private fun MoreIsYetToCome() {
    val colorPalette = ColorMode.current.toPalette()
    Box(
        modifier = Modifier
            .backgroundColor(colorPalette.overlay)
            .borderRadius(30.px)
            .minHeight(260.px), // match WorkItem base height for visual consistency
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            text = "More is yet to come...",
            modifier = TextStyle.toModifier(TitleTextStyleSmaller)
        )
    }
}

@Composable
private fun  TextContent(
    breakpoint: Breakpoint,
) {
    Column(
        modifier = Modifier
            .margin(top = 8.5.cssRem)
            .classNames("scroll-reveal"),  // heading fades up on scroll-in
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            modifier = TextStyle.toModifier(DisplayTextStyle, TextStylePrimaryColor).textAlign(TextAlign.Center),
            text = Res.Strings.WORKS_SECTION_TITLE
        )
        SpanText(
            modifier = TextStyle.toModifier(SubDisplayTextStyle, TextStyleSecondaryColor)
                .maxWidth(if (breakpoint >= Breakpoint.SM) 75.percent else 100.percent)
                .margin(top = 1.cssRem)
                .textAlign(TextAlign.Center),
            text = Res.Strings.WORKS_SECTION_SUBTITLE
        )
    }
}